import { TextLink, Typography } from "@drone-js/core";
import { HStack } from "apps/commons/components/Stack";
import { useDisclosure } from "apps/commons/hooks/useDisclosure";
import { Fragment, Suspense } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ContractCheckboxController } from "./ContractCheckboxController";
import { LocalLawModal } from "./LocalLawModal";
import { TermsModal } from "./TermsModal";

export const AcceptTermsAndConditions = () => {
    const {
        cmsData: {
            publish: { acceptTermsAndCond, iAcknowledge, termsAndConditions, privacyPolicy, localLaws },
        },
    } = useStaticDataAtomValue();

    const termsModal = useDisclosure();
    const localLawsModal = useDisclosure();

    return (
        <Fragment>
            <Typography variant="body-default-strong">{acceptTermsAndCond}</Typography>
            <HStack gap="16">
                <ContractCheckboxController />
                <Typography variant="body-s">
                    {iAcknowledge.split(" ").map((text, index) => {
                        if (text.startsWith("{") && text.match(/{(\d+)}/) !== null)
                            switch (text.match(/{(\d+)}/)[1]) {
                                case "0":
                                    return (
                                        <TextLink
                                            label={termsAndConditions}
                                            onClick={termsModal.onOpen}
                                            data-element-name="terms-conditions"
                                        />
                                    );
                                case "1":
                                    return (
                                        <TextLink
                                            label={privacyPolicy}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://partnerhub.agoda.com/wp-content/uploads/2023/11/agoda.com-nha-host-privacy-policy-2023.11_clean.pdf"
                                            data-element-name="privacy-policy"
                                        />
                                    );
                                case "2":
                                    return (
                                        <TextLink
                                            label={localLaws}
                                            onClick={localLawsModal.onOpen}
                                            data-element-name="local-laws-regulations"
                                        />
                                    );
                                default:
                                    return text;
                            }
                        else if (index !== 0) return " " + text;
                        else return text;
                    })}
                </Typography>
            </HStack>
            <Suspense fallback={null}>
                <TermsModal {...termsModal} />
            </Suspense>
            <LocalLawModal {...localLawsModal} />
        </Fragment>
    );
};
